module.exports = __webpack_public_path__ + "img/undertakingCases25.8ac4faac.jpg";